
import { Options, Vue } from "vue-class-component";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { mapState, mapActions, mapMutations } from "vuex";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueMultiselect from "vue-multiselect";
import Multiselect from "@vueform/multiselect";
import Toggle from "@vueform/toggle";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Chart from "@/components/Chart.vue";
import { DownloadIcon } from "@heroicons/vue/solid";
import { Canvg } from "canvg";
import * as _ from "lodash";
import * as d3 from "d3";

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

@Options({
  components: {
    VueMultiselect,
    Multiselect,
    Toggle,
    Chart,
    DownloadIcon,
  },
  data() {
    return {
      chart_types: [
        {
          name: "map",
          title: "Mapa",
          image: "Mapa",
        },
        {
          name: "bars",
          title: "de Barras",
          image: "Barras",
        },
        {
          name: "heatmap",
          title: "Gráfica de calor",
          image: "Heatmap",
        },
        /*{
          name: "treemap",
          title: "Tipo Árbol",
          image: "Treemap",
        },*/
      ],
      categories: [
        {
          key: "EDAD",
          value: "Edad",
          plural: "Grupos de edad",
          hide_legend: true,
        },
        { key: "SEXO", value: "Sexo", plural: "Sexos", hide_legend: true },
        {
          key: "EDUCACION",
          value: "Educación",
          plural: "Niveles educativos",
        },
        { key: "REGION", value: "Región", plural: "Regiones" },
        {
          key: "COLOR",
          value: "Color de piel",
          plural: "Colores de piel",
          answers: {
            A: "#312d22",
            B: "#3c220b",
            C: "#48372d",
            D: "#664e40",
            E: "#7c6150",
            F: "#977655",
            G: "#b4997e",
            H: "#dfc19b",
            I: "#e0b7b1",
            J: "#efd0ce",
            K: "#faecec",
          },
          hide_legend: true,
        },
        { key: "RELIGION", value: "Religión", plural: "Religión" },
        { key: "INGRESOS", value: "Ingresos", plural: "Ingresos" },
        {
          key: "ESTRATO",
          value: "Estrato sociodemográfico",
          plural: "Estratos sociodemográficos",
        },
        { key: "OCUPACION", value: "Ocupación", plural: "Ocupaciones" },
        { key: "ESTADO", value: "Estado civil", plural: "Estados civiles" },
      ],
    };
  },
  computed: {
    adultQuestions() {
      return this.$store.state.adultQuestions;
    },
    openCategories: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.openCategories;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(newValue) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.openCategories = newValue;
      },
    },
    ...mapState({
      sections: (state: any) => state.sections,
      selectedTopic: (state: any) => state.selectedTopic,
      selectedQuestion: (state: any) => state.selectedQuestion,
      selectedAnswer: (state: any) => state.selectedAnswer,
      selectedChart: (state: any) => state.selectedChart,
      selectedX: (state: any) => state.selectedX,
      selectedY: (state: any) => state.selectedY,
      isPercentage: (state: any) => state.isPercentage,
      questions: (state: any) => state.questions,
      regions: (state: any) => state.regions,
      //answers: (state: any) => state.answers,
      answerOptions: (state: any) => state.answerOptions,
    }),
    currentTopic() {
      return this.selectedTopic;
    },
    categories_hydrated() {
      return this.categories.map((cat: any) => {
        const is_selected =
          cat.key == this.selectedX.key || cat.key == this.selectedY.key;
        const cat_class = `${is_selected ? "" : "in"}active`;
        return { ...cat, ...{ cat_class: cat_class } };
      });
    },
  },
  methods: {
    ...mapActions({
      changeTopic: "CHANGE_TOPIC",
      changeQuestion: "CHANGE_QUESTION",
      changeSelectedXY: "CHANGE_SELECTED_XY",
      cleanSelecteds: "ERASE_SELECTEDS",
      chargeChart: "CHARGE_CHART",
    }),
    ...mapMutations({
      changeIsPercentage: "SET_PERCENTAGE",
      changeAnswer: "SET_ANSWER",
    }),
    wantChangeTopic(new_topic: any) {
      this.changeTopic([new_topic, true]);
    },
    wantChangeQuestion(new_question: any) {
      this.changeQuestion([new_question, true]);
    },
    changeSelected(cat: any, operation: string) {
      //console.log(cat, "here", operation);
      if (!this.selectedX.key) {
        this.changeSelectedXY([cat]);
      } else if (this.selectedX.key == cat.key) {
        if (this.selectedY.key) {
          this.changeSelectedXY([this.selectedY]);
        } else {
          //console.log("por ahora no hago nada");
          this.cleanSelecteds(this.selectedQuestion);
        }
      } else if (this.selectedY.key == cat.key) {
        this.changeSelectedXY([this.selectedX]);
      } else {
        if (this.selectedY.key) {
          this.changeSelectedXY([this.selectedY, cat]);
        } else this.changeSelectedXY([this.selectedX, cat]);
      }
    },
    changeChart(chart_name: string) {
      const need_new_data = this.selectedChart == "map" || chart_name == "map";
      this.chargeChart([chart_name, need_new_data]);
    },
    async downloadChart() {
      let node = document.querySelector<HTMLElement>(
        ".chart-explore #chart-svg"
      );
      if (node) {
        let containerSize = node.getBoundingClientRect();

        const canvas = document.createElement("canvas");

        canvas.id = "canvas";
        canvas.width = containerSize.width;
        canvas.height = containerSize.height;

        const ctx = canvas.getContext("2d");

        let svgStr = new XMLSerializer().serializeToString(node);
        let chartStr = `data:image/svg+xml;base64,${window.btoa(
          unescape(encodeURIComponent(svgStr))
        )}`;

        if (ctx) {
          const svgToCanvas = await Canvg.from(ctx, chartStr);

          // Render only first frame, ignoring animations and mouse.
          await svgToCanvas.render({
            ignoreDimensions: true,
            offsetX:
              containerSize.width / 2 - node.getBoundingClientRect().width / 2,
            offsetY:
              containerSize.height / 2 -
              node.getBoundingClientRect().height / 2,
          });

          // Converting the canvas to blob and getting URL to download in PNG format
          canvas.toBlob(function (blob) {
            const pngUrl = URL.createObjectURL(blob);
            const linkChart = document.createElement("a");
            linkChart.setAttribute("href", pngUrl);
            linkChart.setAttribute("download", "informe-pais-2020.png");
            document.body.appendChild(linkChart);
            linkChart.click();
          });
        }
      }
    },
    downloadData() {
      let formatDataToDownload = [];
      let datatoDownload =
        this.$store.state.selectedChart === "map"
          ? this.$store.state.mapData
          : this.$store.state.questionData;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var headers;

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var dataNest;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var dataUnnest;

      if (
        (!this.$store.state.selectedX.key &&
          !this.$store.state.selectedY.key) ||
        this.$store.state.selectedChart === "map"
      ) {
        // console.log(datatoDownload);

        headers = ["Pregunta", "Respuesta", "Total", "Porcentaje"];

        formatDataToDownload = datatoDownload.data.map((d: any) => {
          return {
            Pregunta:
              this.$store.state.selectedQuestion.NOMBRE_CAMPO.replaceAll(
                ",",
                ""
              ),
            Respuesta: d[
              this.$store.state.selectedQuestion.NEMONICO
            ].replaceAll(",", ""),
            Total: d.factor,
            Porcentaje: d.porcentaje,
          };
        });

        formatDataToDownload = _.sortBy(formatDataToDownload, [
          "Pregunta",
          "Respuesta",
        ]);

        // console.log(formatDataToDownload);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        const total_totales = d3.sum(formatDataToDownload, d => d.Total);

        formatDataToDownload.forEach(d => {
          d.Porcentaje = (d.Total / total_totales) * 100;
          d.Porcentaje = Math.round(d.Porcentaje * 10) / 10;
        });

        // console.log({ total_totales });
      } else if (
        this.$store.state.selectedX.key &&
        this.$store.state.selectedY.key &&
        this.$store.state.selectedChart !== "map"
      ) {
        headers = [
          "Pregunta",
          `${this.$store.state.selectedX.key}`,
          "Respuesta",
          "Total",
          "Porcentaje",
        ];

        headers.splice(2, 0, this.$store.state.selectedY.key);
        formatDataToDownload = datatoDownload.data.map((d: any) => {
          return {
            Pregunta:
              this.$store.state.selectedQuestion.NOMBRE_CAMPO.replaceAll(
                ",",
                ""
              ),
            x: d[this.$store.state.selectedX.key].replaceAll(",", "/"),
            y: d[this.$store.state.selectedY.key].replaceAll(",", "/"),
            Respuesta: d[
              this.$store.state.selectedQuestion.NEMONICO
            ].replaceAll(",", ""),
            Total: d.factor,
            Porcentaje: d.porcentaje,
          };
        });

        formatDataToDownload = _.sortBy(formatDataToDownload, [
          "Pregunta",
          "x",
          "y",
          "Respuesta",
        ]);

        dataNest = d3
          .nest()
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .key(d => d.Pregunta)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .key(d => d.x)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .key(d => d.y)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .rollup(v => d3.sum(v.map(e => e.Total)))
          .entries(formatDataToDownload);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dataUnnest = [];
        dataNest.forEach(one => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          one.values.forEach(two => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            two.values.forEach(v => {
              dataUnnest.push({
                Pregunta: one.key,
                x: two.key,
                y: v.key,
                "Total de Totales": v.value,
              });
            });
          });
        });

        // console.log(dataNest);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // console.log(dataUnnest);

        formatDataToDownload.forEach(d => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const tot = _.find(dataUnnest, {
            Pregunta: d.Pregunta,
            x: d.x,
            y: d.y,
          });
          d.Porcentaje = (d.Total / tot["Total de Totales"]) * 100;
          d.Porcentaje = Math.round(d.Porcentaje * 10) / 10;
        });
      } else if (
        this.$store.state.selectedX.key &&
        !this.$store.state.selectedY.key &&
        this.$store.state.selectedChart !== "map"
      ) {
        headers = [
          "Pregunta",
          `${this.$store.state.selectedX.key}`,
          "Respuesta",
          "Total",
          "Porcentaje",
        ];

        formatDataToDownload = datatoDownload.data.map((d: any) => {
          return {
            Pregunta:
              this.$store.state.selectedQuestion.NOMBRE_CAMPO.replaceAll(
                ",",
                ""
              ),
            key: d[this.$store.state.selectedX.key].replaceAll(",", "/"),
            Respuesta: d[
              this.$store.state.selectedQuestion.NEMONICO
            ].replaceAll(",", ""),
            Total: d.factor,
            Porcentaje: d.porcentaje,
          };
        });

        formatDataToDownload = _.sortBy(formatDataToDownload, [
          "Pregunta",
          "key",
          "Respuesta",
        ]);

        dataNest = d3
          .nest()
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .key(d => d.Pregunta)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .key(d => d.key)
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          .rollup(v => d3.sum(v.map(e => e.Total)))
          .entries(formatDataToDownload);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dataUnnest = [];
        dataNest.forEach(one => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          one.values.forEach(v => {
            dataUnnest.push({
              Pregunta: one.key,
              key: v.key,
              "Total de Totales": v.value,
            });
          });
        });

        // console.log(dataNest);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // console.log(dataUnnest);

        formatDataToDownload.forEach(d => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const tot = _.find(dataUnnest, { Pregunta: d.Pregunta, key: d.key });
          d.Porcentaje = (d.Total / tot["Total de Totales"]) * 100;
          d.Porcentaje = Math.round(d.Porcentaje * 10) / 10;
        });
      }

      formatDataToDownload.unshift(headers);

      // console.log(formatDataToDownload);

      let jsonObject = JSON.stringify(formatDataToDownload);
      //Parsing data to string
      let arr =
        typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;

      let str = "";
      for (let i = 0; i < arr.length; i++) {
        let line = "";
        for (let index in arr[i]) {
          if (line != "") line += ",";
          line += arr[i][index];
        }
        str += line + "\r\n";
      }

      let blob = new Blob(["\uFEFF" + str], {
        type: "text/csv;charset=utf-8;",
      });
      // IE 10+
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, "informe-pais-2020.csv");
      } else {
        let link = document.createElement("a");
        // feature detection
        if (link.download !== undefined) {
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", "informe-pais-2020.csv");
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
  },
})
export default class Explore extends Vue {}
